import { computed } from 'vue'

export async function isAuthRout(to,store) {
	const isAuth = computed(()=>store.state.user.authIsReady)

	if(!isAuth.value){
		await store.dispatch('getRoles')
	    const redirect_path = await store.dispatch('getUser')
	    if (redirect_path){
	      return {
	        path:redirect_path,
	        query: { redirect: to.fullPath },
	      }  
	    }else{
			const options = computed(()=>store.state.apiStorage.options.isLoad)
			if(!options.value){
				store.dispatch('apiStorage/getOptions',{model:'options',params:{}})
			}
		}
	}
	
}